import React from 'react';
import { AEDependent, AERelationshipCode } from '../../models/annual-enrollment-models';
import { getRelationshipLabel, isDependentAgedOut, isDependentAgingOut } from '../../helpers/annual-enrollment-helpers';
import { AnnualEnrollmentProps } from '../../../arc/models/arc-epi-props';
import { DividerSection } from '../../../../global/components/layout/divider-section';
import { firstDayOfNextCalendarYear, getFormattedDate } from '../../../../global/helpers/date-helpers';


interface Props {
	dependents: AEDependent[];
	annualEnrollmentProps: AnnualEnrollmentProps;
	editLink: JSX.Element;
}
export function AnnualEnrollmentDependentsDisplay(props: Props) {
	const { dependents, annualEnrollmentProps, editLink } = props;


	return (
		<>
			<DividerSection sectionText={annualEnrollmentProps?.dependentsReviewHeader || 'Dependents'} secondarySectionNode={editLink}>
				{
					dependents?.map(dep => {
						if (dep?.relationship_code !== AERelationshipCode.Spouse) {
							return (
								<div className='divider-section-item' key={dep.person?._guid}>
									<p>{`${dep.person?.first} ${dep.person?.middle} ${dep.person?.last}`}</p>
									<p className='input-caption'>{getRelationshipLabel(dep?.relationship_code, annualEnrollmentProps)} </p>
									{
										isDependentAgingOut(dep) && <p className='red-text'><strong>{annualEnrollmentProps?.ineligibleDependentsWarning?.replace('{date}', getFormattedDate(firstDayOfNextCalendarYear()?.toString()))}</strong></p>
									}
									{
										isDependentAgedOut(dep) && <p className='red-text'><strong>{annualEnrollmentProps?.dependentAgedOutWarningMessage}</strong></p>
									}
								</div>
							);
						}
						return null;
					})
				}
			</DividerSection>

		</>
	);
}